import React from "react";
import PropTypes from "prop-types";
//Limitless imports
import { ClientContext } from "@limitless/common/utils";
const getStyle = height => {
  let maxHeight = 400;
  if (ClientContext._llmHeight !== "525px") {
    try {
      const llmDiv = document.getElementsByClassName("llm-view-container")[0];
      maxHeight = llmDiv.offsetHeight - 48;
    } catch {
      maxHeight = 400;
    }
  }
  return {
    height,
    backgroundColor: "#fff",
    borderRadius: 12,
    maxHeight,
    overflowY: "auto",
    margin: 8
  };
};
const RateFinishSlide = ({
  height = "100%",
  children
}) => {
  const style = React.useMemo(() => getStyle(height), [height]);
  return /*#__PURE__*/React.createElement("div", {
    className: "embla__slide",
    style: style
  }, children);
};
export default RateFinishSlide;
RateFinishSlide.propTypes = {
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node.isRequired
};